import type { Notification } from '@/api/notifications';

const USER_ID = 'usr-001';

const minutesAgo = (minutes: number): string =>
  new Date(Date.now() - minutes * 60_000).toISOString();

const hoursAgo = (hours: number): string => minutesAgo(hours * 60);

const daysAgo = (days: number): string => hoursAgo(days * 24);

export const mockNotifications: Notification[] = [
  {
    id: 'ntf-001',
    userId: USER_ID,
    type: 'deployment',
    title: 'Deployment succeeded',
    message: 'onering-platform-api v2.4.0 was deployed to production.',
    read: false,
    createdAt: minutesAgo(4),
  },
  {
    id: 'ntf-002',
    userId: USER_ID,
    type: 'incident',
    title: 'Service degradation resolved',
    message: 'Elevated latency on the File Management service has recovered.',
    read: false,
    createdAt: minutesAgo(38),
  },
  {
    id: 'ntf-003',
    userId: USER_ID,
    type: 'access-request',
    title: 'New group access request',
    message: 'Jane Smith requested to join the Platform Team group.',
    read: false,
    createdAt: hoursAgo(2),
  },
  {
    id: 'ntf-004',
    userId: USER_ID,
    type: 'mention',
    title: 'You were mentioned',
    message: 'Alex Johnson mentioned you in a comment on bug report BUG-1429.',
    read: false,
    createdAt: hoursAgo(5),
  },
  {
    id: 'ntf-005',
    userId: USER_ID,
    type: 'release',
    title: 'Release notes published',
    message: 'OneRing Portal v1.9.0 release notes are now available.',
    read: true,
    createdAt: hoursAgo(20),
  },
  {
    id: 'ntf-006',
    userId: USER_ID,
    type: 'security',
    title: 'MFA verification reminder',
    message: 'Two team members have not yet completed MFA setup.',
    read: true,
    createdAt: daysAgo(1),
  },
  {
    id: 'ntf-007',
    userId: USER_ID,
    type: 'file',
    title: 'File processing complete',
    message: 'Your batch upload "march-meter-readings.csv" finished processing.',
    read: true,
    createdAt: daysAgo(2),
  },
  {
    id: 'ntf-008',
    userId: USER_ID,
    type: 'system',
    title: 'Scheduled maintenance',
    message: 'A maintenance window is planned for Sunday at 02:00 UTC.',
    read: true,
    createdAt: daysAgo(3),
  },
];

export const mockUnreadCount = mockNotifications.filter((n) => !n.read).length;
